export enum EClaimStatus {
    New = 0,
    Pending = 1,
    InProgress = 2,
    Successed = 3,
    Failed = 4,
    Canceled = 5
}